import { RewardsType, RewardsValue } from 'app/console-api/apps/types';
import { FlexColumn, FlexRow } from '@make-software/cspr-design';

interface RewardsViewBlockProps {
  rewardValues: RewardsValue[];
  rewardTypes: RewardsType[];
}

export const RewardsViewBlock = ({ rewardValues, rewardTypes }: RewardsViewBlockProps) => {
  if (!Array.isArray(rewardValues) || rewardValues.length === 0) {
    return <div>No rewards available.</div>;
  }
  const getRewardNameByID = (rewardID: number): string => {
    const rewardType = rewardTypes.find((reward) => reward.id === rewardID);
    return rewardType ? rewardType.name : 'Unknown Reward Type';
  };

  return (
    <FlexColumn>
      {rewardValues.map((rewardValue, index) => (
        <FlexRow key={index}>
          {rewardValue.value} - {getRewardNameByID(rewardValue.rewardID)}
        </FlexRow>
      ))}
    </FlexColumn>
  );
};
